import {logger} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'

export const getTemplate = (editId?: DataObjectId): Hub | undefined => {
  if (!editId) {
    return undefined
  }

  const box = Sync.getCurrentSandbox()
  const template = box.getHub(editId)
  if (!template) {
    logger.warn('Cannot find template', editId)
    return undefined
  }

  return template
}
